import { Box, Chip } from "@mui/material";
import ConceptCategory, { DISPLAY_CONCEPT_CATEGORY } from "catalog/types/enums/conceptCategory";

interface ConceptTypeBadgeProps {
  label: string;
  category: ConceptCategory;
}

const ConceptTypeBadge = ({ label, category }: ConceptTypeBadgeProps) => {
  const categoryDisplay = DISPLAY_CONCEPT_CATEGORY[category];

  if (!categoryDisplay) {
    return null;
  }

  const { icon: Icon, iconColor, backgroundColor } = categoryDisplay;

  return (
    <Chip
      size="small"
      variant="outlined"
      sx={{
        px: 0.25,
        color: iconColor,
        fontWeight: 600,
        fontSize: 12,
        cursor: "inherit",
        userSelect: "none",
        border: "none",
        bgcolor: backgroundColor,
      }}
      label={
        <Box display="flex" alignItems="center" gap={0.75}>
          <Icon color={iconColor} width="12px" />
          {label}
        </Box>
      }
    />
  );
};

export default ConceptTypeBadge;
